export default "__VITE_ASSET__Uux5BLBo__"